import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import Modal from '../../../../modules/foundation/components/Modal';
import FishermanLogo from '../FishermanLogo';
import './CloverMakeEditsModal.css';
var defaultProps = {
  open: false
};
var CloverMakeEditsModal = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CloverMakeEditsModal, _React$PureComponent);
  var _super = _createSuper(CloverMakeEditsModal);
  function CloverMakeEditsModal() {
    _classCallCheck(this, CloverMakeEditsModal);
    return _super.apply(this, arguments);
  }
  _createClass(CloverMakeEditsModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        open = _this$props.open,
        onClose = _this$props.onClose,
        onOpen = _this$props.onOpen;
      return /*#__PURE__*/React.createElement(Modal, {
        id: "clover-make-edits-modal",
        trigger: /*#__PURE__*/React.createElement(Button, {
          id: "request-edit-button",
          className: "payment-request-button"
        }, "Make Edits"),
        className: "modal-container clover-make-edits-modal",
        dimmer: "inverted",
        open: open,
        onOpen: onOpen,
        onClose: onClose,
        closeIcon: /*#__PURE__*/React.createElement(Button, {
          id: "inside-close-icon",
          className: "inside-close-icon",
          icon: true,
          onClick: onOpen
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "close"
        }))
      }, /*#__PURE__*/React.createElement(FishermanLogo, null), /*#__PURE__*/React.createElement(Modal.Header, {
        className: "modal-header"
      }, "Make Edits"), /*#__PURE__*/React.createElement("div", {
        className: "modal-content modal-body"
      }, /*#__PURE__*/React.createElement("span", {
        className: "body-text blue-color"
      }, "Fisherman allows for edits and changes to content on the website such as logo, photos, menu, hours and much more. In order to get started though, you must first \u201CSign Up\u201D (via the button at the top of this site) for your free trial. Once you\u2019ve signed up, you will receive an email outlining the steps to begin making edits and changes on the website following the steps outlined to download the Fisherman App in the Clover Marketplace. You will then receive an email with clear instructions.")));
    }
  }]);
  return CloverMakeEditsModal;
}(React.PureComponent);
export { CloverMakeEditsModal as default };
CloverMakeEditsModal.defaultProps = defaultProps;